module.exports = __webpack_public_path__ + "img/smsPush.96fd5992.svg";